import React from "react";
import i18n from "../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import Et3PageTitle from "../../../core/et3-page-title/index";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import FunnelStatsForm from "./funnel-stats-form";
import FunnelStatsData from "./funnel-stats-data";

const KhattabatFunnelStats = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_KHATTABAT_FUNNEL_STATS",
      "SUPERVISOR_KHATTABAT_FUNNEL_STATS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("SUPERVISOR_KHATTABAT_FUNNEL_STATS")}
        subTitle={""}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <FunnelStatsForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <FunnelStatsData />
    </ET3PageDiv>
  );
});
export default KhattabatFunnelStats;
